<nz-card class="header-card" nzSize="small">
  <app-custom-breadcrumb  [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  <div class="flex justify-between my-3">
    <h2 class="my-0" >Members</h2>
    <!-- <button nz-button nzType="primary">Add User</button> -->
  </div>
</nz-card>

<div class="grid grid-cols-3 gap-5">
  <div class="col-span-2" >

    <nz-card class="member-card" nzSize="small" style="padding: 5px">
      <nz-input-group nzSearch nzSize="large"  [nzSuffix]="inputClearTpl" [nzAddOnAfter]="suffixIconButton" style="max-width: 500px">
        <input type="text"  nz-input placeholder="Search Members" [(ngModel)]="searchValue"/>
      </nz-input-group>
      <ng-template #suffixIconButton>
        <button nz-button nzType="primary" (click)="getMembersBySearch()" nzSearch><span nz-icon nzType="search"></span>Search</button>
      </ng-template>
      <ng-template #inputClearTpl>
      <span
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        *ngIf="searchValue"
        (click)="cancelSearch()"
      ></span>
      </ng-template>
    </nz-card>

<div>

    <nz-table class="member-table"
              [nzData]="data"
              [nzPageSize]="pageSize"
              [nzPageIndex]="currentPage"
              [nzTotal]="totalDocs"
              [nzShowPagination]="false"
              >
      <tbody>
      <tr *ngFor="let item of data">
        <td>
          <nz-card nzSize="small">
            <nz-row class="table-row">
              <div class="member-img">
                <img [src]="item.profilePicture?.url" (error)="onImageProfile($event)" alt="user img">
              </div>

              <div class="mobile-res">
                <h4 class="my-0" style="color: #101010">{{item.name}}</h4>
                <p class="font-normal my-0" style="color: #6D6D6D">{{item.position}} · {{item.workplace}}</p>
              </div>

              <div class="view-profile mt-4">
                <p class="view-profile-button font-normal" (click)="viewMember(this.item.id)">View Profile</p>
              </div>

            </nz-row>
          </nz-card>
        </td>
      </tr>
      </tbody>
    </nz-table>
    <div class="flex justify-end" >
      <nz-pagination class="!mt-4" (nzPageIndexChange)="onCurrentPageDataChange($event)" [nzPageIndex]="currentPage" [nzTotal]="totalDocs" [nzPageSize]="pageSize"></nz-pagination>
    </div>


</div>

  </div>
  <div class="col-span-1">
    <nz-card class="p-3 mb-3">

      <div class="user-title">

        <div class="badge-position">
          <div class="user-img mb-2">
            <img [src]="user.profilePicture?.url" (error)="onImageProfile($event)" alt="Image" class="blue-border-img">
            <img src="assets/img/badge.png" alt="badge" class="badge-img">
          </div>
        </div>

       <div class="mt-3" >
          <h4 class="my-0" style="color: #101010">{{this.user.name}}</h4>
          <p class="font-normal my-0" style="color: #6D6D6D">{{this.user.position}}</p>
         <p class="font-normal my-0" style="color: #6D6D6D">{{this.user.grade}}</p>
       </div>

      </div>

      <div class="user-content mt-8">
        <p class="font-normal" style="color: #14171A">{{this.user.description}}</p>
      </div>

    </nz-card>

  </div>
</div>

